export default __webpack_public_path__ + "static/media/790.2529f6ed.png";